import { useQuery } from "@tanstack/react-query";
import { partnerTodayRepo } from "@/data/repos/partnerTodayRepo";
import { todayQueryKey } from "@/features/reservations/hooks/useReservationAnswers";

/** The same key the answers invalidate, so a request confirmed here leaves this
 *  screen and `/reservations` at once. */
export function useToday() {
  const query = useQuery({
    queryKey: todayQueryKey,
    queryFn: () => partnerTodayRepo.get(),
    // The queue is also read from the sidebar of every other screen, where
    // nothing else would ever refresh it — a request left waiting on a tab the
    // partner is not looking at is exactly the one this count is for.
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });

  return {
    today: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
